import { render, staticRenderFns } from "./store.vue?vue&type=template&id=36b22531&scoped=true&"
import script from "./store.vue?vue&type=script&lang=js&"
export * from "./store.vue?vue&type=script&lang=js&"
import style0 from "./store.vue?vue&type=style&index=0&id=36b22531&prod&scoped=true&lang=css&"
import style1 from "./store.vue?vue&type=style&index=1&id=36b22531&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b22531",
  null
  
)

export default component.exports